const tailwind = require('./tailwind');

module.exports = {
  tailwind,
};